import './BandwidthChart.css';

import { PureComponent } from 'react';
import { makeSelectBandwidth, makeSelectMaxbandwidth } from '../selectors';

import { isFeatureFlagEnabled } from '@ipfabric/ui-components/utils/featureFlags';
import LTEBox from 'containers/LTEBox';
import { setSharperSettings } from 'pages/SnapshotManagement/actions';
import PropTypes from 'prop-types';
import { Line as LineChart } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';

class BandwidthChart extends PureComponent {
  static propTypes = {
    bandwidthData: PropTypes.object.isRequired,
    maxBandwidth: PropTypes.string,
    msg: PropTypes.object.isRequired,
    onSetSharperSettings: PropTypes.func.isRequired,
    options: PropTypes.object,
    redraw: PropTypes.bool,
  };

  static defaultProps = {
    redraw: false,
    options: {
      animation: false,
      bezierCurve: true,
      bezierCurveTension: 0.3,
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback(value) {
                return `${Number(value).toLocaleString()} Kb/s`;
              },
            },
          },
        ],
      },
      elements: {
        point: {
          hitRadius: 5,
        },
      },
      legend: {
        onClick: () => {},
      },
      tooltips: {
        mode: 'x-axis',
        bodySpacing: 5,
        callbacks: {
          label: (tooltipItem, data) => {
            const { index, datasetIndex } = tooltipItem;
            return ` ${data.datasets[datasetIndex].data[index].toLocaleString()} Kb/s`;
          },
        },
      },
    },
  };

  getLastValue = () => {
    const { bandwidthData } = this.props;
    const last = bandwidthData.last();
    if (typeof last === 'object') {
      return `${Math.floor(last.rx / 1024).toLocaleString()}/${Math.floor(last.tx / 1024).toLocaleString()}`;
    }
    return 0;
  };

  prepareData = () => {
    const chartData = this.props.bandwidthData.toArray();
    return {
      labels: chartData.map((b) => {
        const d = new Date(b.ts);
        return `${`0${d.getHours()}`.slice(-2)}:${`0${d.getMinutes()}`.slice(
          -2,
        )}:${`0${d.getSeconds()}`.slice(-2)}`;
      }),
      datasets: [
        {
          label: 'RX',
          backgroundColor: 'rgba(151,187,205,0.2)',
          borderColor: 'rgba(151,187,205,1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(151,187,205,1)',
          data: chartData.map((b) => Math.floor(b.rx / 1024)),
        },
        {
          label: 'TX',
          backgroundColor: 'rgba(220,220,220,0.2)',
          borderColor: 'rgba(220,220,220,1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(220,220,220,1)',

          data: chartData.map((b) => Math.floor(b.tx / 1024)),
        },
      ],
    };
  };

  handleSelectChange = handleEvent((e) => {
    const { onSetSharperSettings } = this.props;
    const value = Number.parseInt(e.target.value, 10);
    return onSetSharperSettings(value);
  });

  render() {
    const { maxBandwidth, options, redraw, msg } = this.props;
    const data = this.prepareData();

    return (
      <LTEBox
        bodyComponent={
          <LineChart
            data={data}
            height={250}
            options={options}
            redraw={redraw}
          />
        }
        className='box box-solid box-primary'
        headerComponent={
          <div className='form-inline'>
            <h3 className='box-title'>{msg.bandwidthLimit}</h3>
            &nbsp;&nbsp;
            <select
              className='form-control shaper'
              onChange={this.handleSelectChange}
              style={{ padding: 0, height: '24px', verticalAlign: 'top' }}
              value={maxBandwidth || ''}
            >
              {isFeatureFlagEnabled('ENABLE_SHAPER_DISABLING') && (
                <option value='-1'>{msg.disabled}</option>
              )}
              <option value='1'>{msg.limit.replace('{number}', 1)}</option>
              <option value='2'>{msg.limit.replace('{number}', 2)}</option>
              <option value='3'>{msg.limit.replace('{number}', 3)}</option>
              <option value='4'>{msg.limit.replace('{number}', 4)}</option>
              <option value='5'>{msg.limit.replace('{number}', 5)}</option>
              <option value='10'>{msg.limit.replace('{number}', 10)}</option>
              <option value='20'>{msg.limit.replace('{number}', 20)}</option>
              <option value='30'>{msg.limit.replace('{number}', 30)}</option>
              <option value='40'>{msg.limit.replace('{number}', 40)}</option>
              <option value='50'>{msg.limit.replace('{number}', 50)}</option>
              <option value='60'>{msg.limit.replace('{number}', 60)}</option>
              <option value='70'>{msg.limit.replace('{number}', 70)}</option>
              <option value='80'>{msg.limit.replace('{number}', 80)}</option>
              <option value='90'>{msg.limit.replace('{number}', 90)}</option>
              <option value='100'>{msg.limit.replace('{number}', 100)}</option>
            </select>
            &nbsp;&nbsp;
            {/* <h3 className="box-title">{`${msg.bandwidthUtilization} ${this.getLastValue()} Kb/s`}</h3> */}
            <h3 className='box-title'>
              {msg.bandwidthUtilization.replace(
                '{number}',
                this.getLastValue(),
              )}
            </h3>
          </div>
        }
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  bandwidthData: makeSelectBandwidth(),
  maxBandwidth: makeSelectMaxbandwidth(),
});

function mapDispatchToProps(dispatch) {
  return {
    onSetSharperSettings: (args) => dispatch(setSharperSettings(args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BandwidthChart);
